export default __webpack_public_path__ + "static/login-desktop-670658f669eaff8911796deed7c525f6.png";